const APPLICATION = 'application/json';

const headers = {
    'Accept'       : APPLICATION,
    'Content-Type' : APPLICATION,
};

export const GET = () => ( {
    method  : 'GET',
    headers,
    mode    : 'cors',
} );




// WEBPACK FOOTER //
// ./src/functions/rest-api/config.js